<template>
  <div>
    <v-data-table
      v-if="tasks.length"
      :disable-pagination="true"
      :headers="correspondenceTaskHeaders"
      :hide-default-footer="true"
      :hide-default-header="!tasks.length"
      :items="tasks"
      :items-per-page="-1"
      dense
      @dblclick:row="openRow">
      <template #bottom></template>
      <template #item.responsible="{ item }">
        {{ getPersonName(item.author, { initials: true }) }}
        {{ ` (${item.author?.post || 'Посада відсутня'})` }}
      </template>
      <template #item.actions="{ item }">
        <b-action-menu
          :actions="[
            {
              title: 'Відкріпити завдання',
              action: () => removeTask(item.id),
              icon: 'mdi-delete-forever',
              iconProps: {
                color: 'error',
              },
            },
          ]">
        </b-action-menu>
      </template>
    </v-data-table>
    <ContentNotFound v-else />
  </div>
</template>

<script lang="ts">
import { taskUpdate } from '@/requests/task'
import { setSnackbar } from 'best-modules/plugins'
import { getPersonName } from 'best-modules/utils'
import { BActionMenu } from 'best-modules/components'
import { ref } from 'vue'
import { navigateToItem } from '@/utils/helpers'
import { correspondenceTaskHeaders } from '@/utils/tableHeaders'
import ContentNotFound from '@/components/ContentNotFound.vue'

export default {
  name: 'Tasks',
  components: { ContentNotFound, BActionMenu },
  props: {
    dialog: { type: Object, required: true },
  },
  data: () => ({
    correspondenceTaskHeaders,
  }),
  methods: { getPersonName },
  setup(props) {
    const tasks = ref(props.dialog.dialogData?.correspondence.tasks || [])

    const removeTask = (taskId: any) => {
      return taskUpdate(taskId, {
        entityId: null,
        entityTypeId: null,
      }).then(res => {
        setSnackbar({
          color: 'success',
          text: 'Завдання успішно відкріплене',
        })
        tasks.value = tasks.value.filter((item: any) => item.id !== taskId)
        return res
      })
    }
    const openRow = (e: any, row: any) => {
      navigateToItem('single-task', row.item.id)
    }
    return {
      removeTask,
      tasks,
      openRow,
    }
  },
}
</script>
